export default __webpack_public_path__ + "static/media/recruitee.df8c737b.png";